"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var then_ajax_1 = require("then-ajax");
var history_1 = require("./history");
var util_1 = require("~/js/lib/util/util");
var theme_1 = require("~@/widget/theme/theme");
require("./right-history.scss");
var HISTORY_LIMIT = 7;
var FETCH_INTERVAL = 300;
var INTERFACE = {
    MY_WATCH_HISTORY: '//www.yy.com/api/live/current'
};
var history = new history_1.History();
var RightHistory = (function (_super) {
    __extends(RightHistory, _super);
    function RightHistory(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            historys: [],
            isHover: false,
            isLoading: true
        };
        history.init(props.userInfo.uid)["catch"](function () { return undefined; });
        _this.fetchHistory = util_1.debounce(function () { return __awaiter(_this, void 0, void 0, function () {
            var historys, iHistorys, queryArr_1, rs, dataMap_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        historys = history.historys;
                        iHistorys = [];
                        if (!historys) return [3, 2];
                        queryArr_1 = [];
                        historys.forEach(function (item) {
                            queryArr_1.push({
                                topCid: item.topCid,
                                subCid: item.subCid
                            });
                        });
                        return [4, then_ajax_1.thenGet(INTERFACE.MY_WATCH_HISTORY, {
                                query: JSON.stringify(queryArr_1).replace(/{/g, '%7B').replace(/}/g, '%7D')
                            })];
                    case 1:
                        rs = _a.sent();
                        dataMap_1 = {};
                        if (rs.code === 0 &&
                            rs.data &&
                            rs.data.length) {
                            rs.data.forEach(function (item) {
                                dataMap_1[item.topCid + "-" + item.subCid] = item;
                            });
                        }
                        historys.forEach(function (item) {
                            var iResData = dataMap_1[item.topCid + "-" + item.subCid];
                            iHistorys.push({
                                sid: +item.topCid,
                                ssid: +item.subCid,
                                name: decodeURIComponent(item.roomName),
                                url: theme_1.DOMAIN + "/" + item.topCid + "/" + item.subCid + "/",
                                isLive: iResData ? (iResData.status === '2' ? true : false) : false,
                                expires: item.expires
                            });
                        });
                        iHistorys = iHistorys.sort(function (aItem, bItem) {
                            if (aItem.isLive && !bItem.isLive) {
                                return -1;
                            }
                            else if (!aItem.isLive && bItem.isLive) {
                                return 1;
                            }
                            else {
                                return bItem.expires - aItem.expires;
                            }
                        });
                        _a.label = 2;
                    case 2:
                        this.setState({
                            historys: iHistorys,
                            isLoading: false
                        });
                        return [2];
                }
            });
        }); }, FETCH_INTERVAL);
        return _this;
    }
    RightHistory.prototype.render = function () {
        var _a = this.state, historys = _a.historys, isHover = _a.isHover, isLoading = _a.isLoading;
        var _b = this.props, login = _b.login, isLogined = _b.isLogined, userInfo = _b.userInfo;
        return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--history", onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this) },
            React.createElement("a", { className: "p-header__main__cnt__right__item__tl", href: "javascript:;" },
                React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
                React.createElement("span", { className: "p-header__main__cnt__right__item__tl__t" }, "\u5386\u53F2")),
            React.createElement("div", { className: "p-header__drag " + (isHover ? 'p-header__drag--show' : '') + " " + (isLoading ? 'p-header__drag--loading' : '') },
                React.createElement("span", { className: "p-header__drag__enterstage" },
                    React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                    React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                React.createElement("div", { className: "p-header__drag__main" },
                    React.createElement("div", { className: "p-header__history__cnt" },
                        historys.length === 0 && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "p-header__blank" },
                                React.createElement("span", { className: "p-header__blank__t" }, "\u5C0F\u4E3B, \u5F88\u4E45\u6CA1\u6709\u770B\u76F4\u64AD\u4E86\u54E6~")),
                            React.createElement("div", { className: "p-header__loginbtn" },
                                React.createElement("a", { className: "p-header__loginbtn__link", href: "javascript:;" }, "\u53BB\u770B\u76F4\u64AD")))),
                        historys.length > 0 && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "p-header__history__cnt__l" },
                                React.createElement("ul", { className: "p-header__history__cnt__l__ul" }, historys.slice(0, HISTORY_LIMIT).map(function (item, index) {
                                    return (React.createElement("li", { className: "p-header__history__cnt__l__ul__li " + (item.isLive ? 'isliving' : ''), key: index },
                                        React.createElement("a", { className: "p-header__history__cnt__l__ul__box", href: item.url },
                                            React.createElement("span", { className: "p-header__history__cnt__l__ul__box__s1" }, item.name),
                                            React.createElement("i", { className: "p-header__history__cnt__l__ul__box__icon-live" }))));
                                }))),
                            React.createElement("div", { className: "p-header__more" },
                                isLogined && (React.createElement("a", { className: "p-header__more__link", href: "https://www.yy.com/i/index/history", target: "_blank" }, "\u67E5\u770B\u66F4\u591A >")),
                                !isLogined && (React.createElement("a", { className: "p-header__more__link", href: "javascript", onClick: function () { return login(); } }, "\u67E5\u770B\u66F4\u591A >"))))))))));
    };
    RightHistory.prototype.componentWillUpdate = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, isLogined, userInfo, isHover, fetchHistory;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, isLogined = _a.isLogined, userInfo = _a.userInfo;
                        isHover = this.state.isHover;
                        fetchHistory = this.fetchHistory;
                        if (!(isLogined !== nextProps.isLogined)) return [3, 2];
                        return [4, history.init(userInfo.uid)];
                    case 1:
                        _b.sent();
                        this.setState({
                            isLoading: true,
                            historys: []
                        }, function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!isHover) return [3, 2];
                                        return [4, fetchHistory()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2];
                                }
                            });
                        }); });
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    RightHistory.prototype.onMouseEnter = function () {
        this.setState({
            isHover: true
        });
        this.fetchHistory();
    };
    RightHistory.prototype.onMouseLeave = function () {
        this.setState({
            isHover: false
        });
    };
    RightHistory.prototype.add = function (op) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, history.add(op)];
                    case 1:
                        r = _a.sent();
                        return [2, r];
                }
            });
        });
    };
    return RightHistory;
}(React.Component));
exports.RightHistory = RightHistory;
